import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, CardMedia, IconButton, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { J3Onoff } from '@e3dc-react/icons'
import { useTypedSelector } from 'src/State/RootReducer'
import { useDispatch } from 'react-redux'
import { removeSmartMeter } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationAction'
import { Product, getImageUrlBySize } from 'src/Libs/shop'
import { ShopImageThumnbailSizes } from 'src/Libs/shop/types'

interface SmartMeterSystemConfigurationCardProps {
  selectedSmartMeter: Product
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  icon: {
    color: theme.palette.text.headerTitle,
    transform: 'rotate(90deg)',
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  productImage: {
    width: '45px',
    maxWidth: '45px',
    height: 'auto',
  },
}))

/*
 * This component shows the smartmeter card on configured system sidebar
 */
const SmartMeterSystemConfigurationCard: React.FC<SmartMeterSystemConfigurationCardProps> = ({ selectedSmartMeter }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const configuratorItems = useTypedSelector(state => state.systemStorage.items)
  const smartMeter = configuratorItems.length > 0 ? configuratorItems[0].configuration.smartMeter : null

  const handleSmartMeterRemove = (): void => {
    dispatch(removeSmartMeter())
  }

  return (
    <Stack>
      {smartMeter && smartMeter.id !== null && (
        <Typography variant="h5" mt={2}>
          {t('shop.system-configure-card.smart-meter')}
        </Typography>
      )}
      {selectedSmartMeter && (
        <Box className={classes.mainComponentWrapper}>
          <Box className={classes.spaceBetween}>
            <Box>
              <CardMedia
                component="img"
                image={getImageUrlBySize(selectedSmartMeter?.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)}
                className={classes.productImage}
              />
            </Box>
            {selectedSmartMeter.translated && (
              <Typography variant="h4" sx={{ wordBreak: 'break-all' }}>
                {selectedSmartMeter.translated.name}
              </Typography>
            )}
          </Box>

          <IconButton
            onClick={() => {
              handleSmartMeterRemove()
            }}
          >
            <J3Onoff fontSize="large" className={classes.icon} />
          </IconButton>
        </Box>
      )}
    </Stack>
  )
}

export default SmartMeterSystemConfigurationCard
